export const BILLIN_SERVICE_ID = "cmjcrj5ad000gg8xz8icco4jr";
export const BILLIN_PACKAGE_ID = "cmjcrj5ad000jg8xzl9lisdcw";

export const BILLIN_DEFAULT_WORKER_ID = "bill-lin-income";

export const BILLIN_RECEIVABLE_WORKER_ID = "bill-lin-receivable";
export const BILLIN_RECEIVABLE_SLIP_WORKER_ID = "bill-lin-receivable-slip";
export const BILLIN_RECEIVABLE_ADDRESS_WORKER_ID = "bill-lin-receivable-address";
export const BILLIN_RECEIVABLE_INACTIVE_WORKER_ID =
  "bill-lin-receivable-inactive";

export type ReceivableTabKind = "announcement" | "slip" | "address";

export const BILLIN_RECEIVABLE_WORKER_IDS = [
  BILLIN_RECEIVABLE_ADDRESS_WORKER_ID,
  BILLIN_RECEIVABLE_SLIP_WORKER_ID,
  BILLIN_RECEIVABLE_WORKER_ID,
] as const;

export function isBillinReceivableWorkerId(workerId: string): boolean {
  return (BILLIN_RECEIVABLE_WORKER_IDS as readonly string[]).includes(workerId);
}

export function isBillinReceivableInactiveWorkerId(workerId: string): boolean {
  return workerId === BILLIN_RECEIVABLE_INACTIVE_WORKER_ID;
}

export function receivableKindFromWorkerId(
  workerId: string,
): ReceivableTabKind | null {
  switch (workerId) {
    case BILLIN_RECEIVABLE_WORKER_ID:
      return "announcement";
    case BILLIN_RECEIVABLE_SLIP_WORKER_ID:
      return "slip";
    case BILLIN_RECEIVABLE_ADDRESS_WORKER_ID:
      return "address";
    default:
      return null;
  }
}

export const BILLIN_DEFAULT_TABLE_FILTERS = {
  filter_sort: "record_date",
  filter_dir: "desc",
} as const;

export const SIGNIN_BILLIN_WORKSPACE_ID_KEY = "signin_billin_workspace_id_v1";
